import { useHighlightedContent, useRenderHtml } from '../../hooks'

export default function PageContent({ content }) {
  return useRenderHtml(useHighlightedContent(content))
}
